'use strict';

module.exports = function() {
	this.onResize('removeListeners');
	this.onScroll('removeListeners');
	this.clear();
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/granim/lib/destroy.js
// module id = 43
// module chunks = 0